import { useFlag } from '@reflag/react-sdk';
import { skipToken, useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';

import { apiQuery } from '../../state';
import { siteVisitorCountrySelector } from './state';

/**
 * Regions declared by a site adaptive schema, and the visitor country currently previewed for the site
 * with the region it belongs to.
 */
export function useSiteVisitorCountry(args: { organizationId: string; siteId: string }) {
    const { organizationId, siteId } = args;
    const [selectedCountry, setCountry] = useAtom(siteVisitorCountrySelector(siteId));

    const hasRegionEnabled = useFlag('ADAPTIVE_CONTENT_REGION').isEnabled;
    const { data: siteSchema } = useQuery(
        apiQuery(
            'getSiteAdaptiveSchema',
            hasRegionEnabled ? { organizationId, siteId } : skipToken,
            { nullOnError: true }
        )
    );
    const regions = siteSchema?.jsonSchema.regions ?? {};
    // The country may have been removed from the schema regions since it was picked.
    const region = selectedCountry
        ? Object.entries(regions).find(([, group]) =>
              group?.countries.some((code) => code === selectedCountry)
          )?.[0]
        : undefined;
    const country = region && selectedCountry ? selectedCountry : undefined;

    return { regions, country, region, setCountry };
}
